"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const __1 = require("../../..");
function HeaderTitle({ ariaLabel, children }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: "usa-logo", id: "header-logo", children: (0, jsx_runtime_1.jsx)("em", { className: "usa-logo__text", children: (0, jsx_runtime_1.jsx)(__1.Link, { href: "/", title: "Home", "aria-label": ariaLabel, children: children }) }) }));
}
exports.default = HeaderTitle;
